<template lang="pug">
services-listing
</template>

<script>
import ServicesListing from '@/components/hq/inventory/services/ServicesListing.vue'

export default {
  components: {
    ServicesListing
  }
}
</script>
